import { useEffect, useState } from "react";
import { getSettings } from "@/lib/settings";

export const LogoMark = ({ size = 26 }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" aria-hidden="true">
    <rect width="64" height="64" fill="#C8FF1E" />
    <path d="M12 52V12h10l10 18 10-18h10v40h-9V28L32 48 21 28v24z" fill="#F7F7F2" />
  </svg>
);

export const useLogoUrl = () => {
  const [logoUrl, setLogoUrl] = useState("");
  useEffect(() => {
    getSettings().then((s) => setLogoUrl(s.logo_url || ""));
  }, []);
  return logoUrl;
};

export const Logo = () => {
  const logoUrl = useLogoUrl();
  return (
    <span className="flex items-center gap-2.5">
      <span className="transition-transform duration-300 group-hover:rotate-90 flex items-center">
        {logoUrl ? (
          <img src={logoUrl} alt="Marabou Design logo" className="h-7 w-7 object-contain" data-testid="custom-logo" />
        ) : (
          <LogoMark />
        )}
      </span>
      <span className="font-display font-extrabold tracking-tighter text-lg uppercase leading-none">
        Marabou<span className="ml-1.5 text-[#4D7C0F]">Design</span>
      </span>
    </span>
  );
};
